var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10L13.2071 9.29289L13.9142 10L13.2071 10.7071L12.5 10ZM8.20711 4.29289L13.2071 9.29289L11.7929 10.7071L6.79289 5.70711L8.20711 4.29289ZM13.2071 10.7071L8.20711 15.7071L6.79289 14.2929L11.7929 9.29289L13.2071 10.7071Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandRight);
export default __webpack_public_path__ + "static/media/expand_right.28dc48e86ef97a848aa6ce1deb63809e.svg";
export { ForwardRef as ReactComponent };